import Swal from 'sweetalert2';

// Configuração padrão do SweetAlert com tema do Valora (teal/cyan)
const defaultConfig = {
  confirmButtonColor: '#17c1e8',
  cancelButtonColor: '#6c757d',
  buttonsStyling: true,
  customClass: {
    confirmButton: 'btn btn-custom-gradient',
    cancelButton: 'btn btn-secondary',
  },
};

// Função para mostrar alerta de sucesso
export function showSuccessAlert(title, message, timer = 3000) {
  return Swal.fire({
    ...defaultConfig,
    icon: 'success',
    title: title || 'Sucesso!',
    text: message || '',
    timer: timer,
    timerProgressBar: true,
    showConfirmButton: true,
    confirmButtonText: 'OK',
    background: '#fff',
    iconColor: '#20c997',
    confirmButtonColor: 'transparent',
    customClass: {
      confirmButton: 'swal2-confirm btn-custom-gradient',
      popup: 'swal2-popup-valora',
    },
  });
}

// Função para mostrar alerta de erro
export function showErrorAlert(title, message) {
  return Swal.fire({
    ...defaultConfig,
    icon: 'error',
    title: title || 'Erro!',
    text: message || '',
    confirmButtonText: 'OK',
    confirmButtonColor: '#ea0606',
  });
}

// Função para mostrar alerta de confirmação
export function showConfirmAlert(title, message, confirmText = 'Confirmar', cancelText = 'Cancelar') {
  return Swal.fire({
    ...defaultConfig,
    icon: 'question',
    title: title || 'Confirmar',
    text: message || '',
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    reverseButtons: true,
  });
}

// Função para mostrar alerta de informação
export function showInfoAlert(title, message) {
  return Swal.fire({
    ...defaultConfig,
    icon: 'info',
    title: title || 'Informação',
    text: message || '',
    confirmButtonText: 'OK',
    confirmButtonColor: '#17c1e8',
  });
}

// Função para mostrar alerta de aviso
export function showWarningAlert(title, message) {
  return Swal.fire({
    ...defaultConfig,
    icon: 'warning',
    title: title || 'Atenção!',
    text: message || '',
    confirmButtonText: 'OK',
    confirmButtonColor: '#fbcf33',
  });
}

export default Swal;

